import { ApolloProvider } from '@apollo/client';
import React, { ReactNode, useMemo } from 'react';
import configureApolloClient from './infrastructure/configureApolloClient';
import IStore from './infrastructure/store.interface';
import { useWalkmeSdkService } from './infrastructure/WalkmeSdkProvider/useWalkmeSdkService';
import { Store } from 'redux';

export const ApolloProviderWrapper = ({ store, children }: { store: Store<IStore>; children: ReactNode }) => {
    const { shellSdk } = useWalkmeSdkService();
    const client = useMemo(() => configureApolloClient({ store, shellSdk }), [shellSdk, store]);
    return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
